/**
 * API Configuration
 * Automatically selects the correct API endpoint based on environment
 */

const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "127.0.0.1" || window.location.hostname === "localhost");

const API_BASE =
  process.env.REACT_APP_API_URL ||
  (isLocalHost ? "http://127.0.0.1:5001" : "https://autologg.onrender.com");

export default API_BASE;
